import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileSubmitLayout from '../MobileSubmitLayout';
import ImagePreviewWithDisplayOptions from '../../common/ImagePreviewWithDisplayOptions';
import TitleField from '../../../fields/TitleField';
import DescriptionField from '../../../fields/DescriptionField';
import AllowFreeDownloadField from '../../../fields/AllowFreeDownloadField';
import LabelsField from '../../../fields/LabelsField';
import LicenseField from '../../../fields/LicenseField';
import LegalDocumentsField from '../../../fields/LegalDocumentsField';
import DisableCommentsField from '../../../fields/DisableCommentsField';
import ScrapsToggleField from '../../../fields/ScrapsToggleField';
import NotifyWatchersField from '../../../fields/NotifyWatchersField';
import FieldsGroup from '../../common/FieldsGroup';
import HorizontalSeparator from '../../common/HorizontalSeparator';
import TagsField from '../../../fields/TagsField';
import RecommendedTagsField from '../../../fields/RecommendedTagsField';
import DisplayOptionsField from '../../../fields/DisplayOptionsField';
import OriginalsVisibilityField from '../../../fields/OriginalsVisibilityField';
import ExclusiveAttachmentsField from '../../../fields/ExclusiveAttachmentsField';
import OriginalsResaleField from '../../../fields/OriginalsResaleField';
import LabelOptionsForm from '../../../common/LabelOptionsForm';

import s from './OriginalsDeliveryForm.scss';

interface Props {}

const OriginalsDeliveryForm: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <MobileSubmitLayout preview={<ImagePreviewWithDisplayOptions compact />}>
      <TitleField />
      <LabelOptionsForm />
      <TagsField />
      <RecommendedTagsField withBottomMargin />
      <DescriptionField />

      <FieldsGroup className={s['originals-fields-group']}>
        <OriginalsResaleField />
        <ExclusiveAttachmentsField />
        <OriginalsVisibilityField />
      </FieldsGroup>
      <DisplayOptionsField isLabelHidden={false} />

      <HorizontalSeparator margins="both" />
      <FieldsGroup title={t('deviationSubmit.form.section.advanced.title')} isCollapsible>
        <LabelsField />
        <LicenseField />
        <LegalDocumentsField />
        <DisableCommentsField />
        <ScrapsToggleField />
        <NotifyWatchersField />
        <AllowFreeDownloadField />
      </FieldsGroup>
    </MobileSubmitLayout>
  );
};
OriginalsDeliveryForm.displayName = 'OriginalsDeliveryForm';

export default OriginalsDeliveryForm;
